module.exports = __webpack_public_path__ + "static/img/bg.0228dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fresh/bg.png
// module id = yuAK
// module chunks = 1